import React, { useContext, useEffect, useState, useRef } from 'react';
import AppContext from '../AppContext/AppContext';
import { LoadingButton } from '@mui/lab';
import axios from 'axios';
import Iconify from '../Iconify/Iconify';
import { useParams } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import './Panel.scss';
import { Button, TextField, Switch, IconButton, InputAdornment } from '@mui/material';
import 'react-tagsinput/react-tagsinput.css';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import EditorContext from '../EditorContext/EditorContext';
import jsonminify from 'jsonminify';
import { Config } from '../../Config';
import { Block } from '@mui/icons-material';
import { Scrollbars } from 'react-custom-scrollbars-2';

function Panel(props: any) {
	const { projectId } = useParams();
	const { openModal, setOpenModal, project } = props;
	const { state, dispatch } = useContext(AppContext);
	const { task, setTask } = useContext(EditorContext);
	const [exportLoading, setExportLoading] = useState(false);
	const [exportText, setExportText] = useState('Export');
	const [exportJson, setExportJson] = useState('');
	const [canCopyTemplate, setCanCopyTemplate] = useState(false);
	const [canCopyFontface, setCanCopyFontface] = useState(false);
	const [copyFontfaceText, setCopyFontfaceText] = useState('Copy CSS @font-face');
	const [reduceDomSize, setReduceDomSize] = useState(false);
	const [reduceDomSizeLevel, setReduceDomSizeLevel] = useState('standard');
	const [mergeElementsEnable, setMergeElementsEnable] = useState(true);
	const [showWebflowAPIToken, setShowWebflowAPIToken] = useState(false);
	const [webflowAPIToken, setWebflowAPIToken] = useState(project?.settings?.webflowAPIToken || '');
	const [webflowUploadAssets, setWebflowUploadAssets] = useState(false);
	const [isOpenAdvanced, setIsOpenAdvanced] = useState(false);
	const [figmaLink, setFigmaLink] = useState('');
	const [panelHeight, setPanelHeight] = useState(state.license.licenseId === 'free' ? 'calc(100vh - 290px)' : 'calc(100vh - 197px)');
	let panelRef = useRef<HTMLDivElement | null>(null);
	const [breakpoints, setBreakpoints] = useState<any>(
		{
			desktop: 1025,
			tablet: 1024,
			mobile: 767,
		}
	);
	const [breakpointsElementor, setBreakpointsElementor] = useState<any>(
		{
			desktop: 1025,
			tablet: 1024,
			mobile: 767,
		}
	);
	const [breakpointsElementorFree, setBreakpointsElementorFree] = useState<any>(
		{
			desktop: 1025,
			tablet: 1024,
			mobile: 767,
		}
	);
	const [breakpointsWebflow, setBreakpointsWebflow] = useState<any>(
		{
			desktop: 992,
			tablet: 991,
			mobileLandscape: 767,
			mobile: 478,
		}
	);
	const [breakpointsBricks, setBreakpointsBricks] = useState<any>(
		{
			desktop: 992,
			tablet: 991,
			mobileLandscape: 767,
			mobile: 478,
		}
	);
	const [breakpointsBreakdance, setBreakpointsBreakdance] = useState<any>(
		{
			desktop: 1120,
			tabletLandscape: 1119,
			tablet: 1023,
			phoneLandscape: 767,
			mobile: 479
		}
	);
	const [breakpointsGutenberg, setBreakpointsGutenberg] = useState<any>(
		{
			desktop: 1120,
			tablet: 780,
			mobile: 478
		}
	);
	const [builder, setBuilder] = useState('elementorFree');
	const [copyFontface, setCopyFontface] = useState('export');
	const [fontFace, setFontFace] = useState<any>(null);
	const navigate = useNavigate();
	const [jsonString, setJsonString] = useState('');
	const [error, setError] = useState<any>(null);
	const [upgrade, setUpgrade] = useState(state.license.licenseId === 'free');
	const [uploadDocURL, setUploadDocURL] = useState<string>('https://softlite.io/docs/clonewebx/elementor-use-images-or-icons-instead-of-source-links/');
	const [mergeElementsDocURL, setMergeElementsDocURL] = useState<string>('https://softlite.io/docs/clonewebx/merge-elements/');
	const [cssSelector, setCssSelector] = useState('body');
	const [exportType, setExportType] = useState('selector');

	let snippetRef = useRef<any>(null);

	const handleExport = async () => {
		if (figmaLink.trim() === '') {
			setError('Please enter the Figma link');
			return;
		}

		if (figmaLink.trim() !== '' && error && error !== 1) {
			return;
		}

		try {
			setExportLoading(true);

			const option = {
				method: 'POST',
				url: '/api/v1/export/',
				headers: {
					Authorization: `Bearer ${localStorage.getItem('token')}`,
				},
				data: {
					projectId: projectId,
					exportType: exportType,
					selector: cssSelector,
					breakpoints: breakpoints,
					builder: builder,
					copyFontface: copyFontface,
					reduceDomSize: reduceDomSize ? reduceDomSizeLevel : null,
					webflowAPIToken: webflowAPIToken,
					webflowUploadAssets: webflowUploadAssets,
					figmaLink: figmaLink,
					mergeElementsEnable: mergeElementsEnable,
				},
			};

			const res = await axios(option);
			const { task } = res.data.data;
			dispatch({ type: 'CREATE_ONE_TASK', payload: res.data.data });

			if (state.tasksRemaining !== -1) {
				dispatch({ type: 'GET_TASKS_REMAINING', payload: state.tasksRemaining - 1 });
			}

			const tasks = state.user ? state.tasks : [];
			// localStorage.setItem('tasks', JSON.stringify(tasks.concat(task)));

			setError(null);
			setOpenModal(false);
		} catch (error: any) {
			if (error.response?.data?.error) {
				setError(error.response.data.error);
			}

			if (error.response?.status === 409 && error.response.data.error === 10) {
				setUpgrade(true);
			}
		} finally {
			setExportLoading(false);
		}
	}

	const handleCopyWebflow = () => {
		document.execCommand('copy');
	};

	document.addEventListener("copy", function (event) {
		event.preventDefault();
		event?.clipboardData?.setData("application/json", JSON.stringify(exportJson));

		setExportText('Copied to clipboard');
		setTimeout(() => {
			setExportText('Export');
		}, 3000);
	});

	const copyJsonToClipboard = (data: any) => {
		if (data) {
			let jsonString = '';

			switch (builder) {
				case 'elementor':
				case 'elementorFree':

					jsonString = JSON.stringify({ type: 'elementor', siteurl: 'https://elementor.com/wp-json/', elements: data.content }, null, 2);

					break;

				case 'bricks':

					jsonString = JSON.stringify({
						content: data.content,
						source: 'bricksCopiedElements',
						sourceUrl: '',
						version: '1.9.2',
						globalClasses: data.globalClasses,
						globalElements: []
					}, null, 2);

					break;
				case 'breakdance':
					jsonString = JSON.stringify(data, null, 2);
					break;
			}

			const jsonStringMinified = builder === 'gutenberg' ? data : JSON.stringify(JSON.parse(jsonString));

			navigator.clipboard.writeText(jsonStringMinified)
				.then(() => {
					setExportText('Copied to clipboard');
					setTimeout(() => {
						setExportText('Export');
					}, 3000);
				})
				.catch((error) => {
					console.error('Error copying JSON data to clipboard:', error);
				});
		}
	};

	useEffect(() => {
		setCanCopyFontface(false);
	}, [copyFontface, exportType, builder, cssSelector]);

	const handleCopyFontface = () => {
		navigator.clipboard.writeText('<style>' + fontFace + '</style>')
			.then(() => {
				setCopyFontfaceText('Copied to clipboard');
				setTimeout(() => {
					setCopyFontfaceText('Copy CSS @font-face');
				}, 3000);
			})
			.catch((error) => {
				console.error('Error copying data to clipboard:', error);
			});
	};

	useEffect(() => {
		setCanCopyTemplate(false);
	}, [exportType, builder, cssSelector]);

	useEffect(() => {
		setError(null);
		checkFigmaLink(figmaLink);
	}, [builder]);

	useEffect(() => {
		const fetchSites = async () => {
			try {
				const option = {
					method: 'PUT',
					url: '/api/v1/webflow/',
					headers: {
						Authorization: `Bearer ${localStorage.getItem('token')}`,
					},
					data: {
						projectId: projectId,
						webflowAPIToken: webflowAPIToken,
					},
				};

				const res = await axios(option);

			} catch (error: any) {
				console.error('Error fetching sites:', error.response ? error.response.data : error.message);
			}
		};

		if (webflowAPIToken) {
			fetchSites();
		}

	}, [webflowAPIToken]);

	useEffect(() => {
		if (task?.settings?.webflowAPIToken) {
			setWebflowAPIToken(task?.settings?.webflowAPIToken);
		}
	}, [task]);

	useEffect(() => {
		switch (builder) {
			case 'elementorFree':
				setUploadDocURL('https://softlite.io/docs/clonewebx/elementor-use-images-or-icons-instead-of-source-links/');
				break;
			case 'webflow':
				setUploadDocURL('https://softlite.io/docs/clonewebx/webflow-use-images-or-icons-instead-of-source-links/');
				break;
			case 'bricks':
			case 'breakdance':
				setUploadDocURL('https://softlite.io/docs/clonewebx/use-images-or-icons-instead-of-source-links/');
				break;
		}
	}, [builder]);

	const checkFigmaLink = (figmaLink: string) => {
		if (figmaLink.trim() !== '') {
			if (
				!figmaLink.includes('//www.figma.com/design/') ||
				!figmaLink.includes('?node-id=') ||
				figmaLink.includes('m=dev') ||
				figmaLink.includes('node-type=canvas')
			) {
				if (figmaLink.includes('m=dev')) {
					setError('Please switch to the design mode in Figma and then copy the link to selection again');
				} else {
					setError('Invalid Figma link to selection');
				}
			} else {
				setError(null);
			}
		} else {
			setError(null);
		}
	}

	const renderThumb = () => {
		return (
			<div style={{ background: '#212426', borderRadius: '100px' }} />
		);
	}

	return (
		<div className="panel" ref={panelRef}>
			<div className="panel__inner">
				<div className="controls">
					<div className="controls__body">

						<div className="controls__field-group controls__field-group--label-block">
							<label htmlFor="figmaLink">
								Figma link to selection <a href="https://softlite.io/docs/figwebx/import-from-figma/" target="_blank" rel="noreferrer" style={{marginLeft:'5px'}}><strong>→ Please follow this document</strong></a>
							</label>
							
							<TextField
								id="figmaLinke"
								name='figmaLinke'
								value={figmaLink}
								onChange={(e) => {
									const figmaLinkValue = e.target.value;
									checkFigmaLink(figmaLinkValue);
									setFigmaLink(e.target.value);
								}}
							/>

							<div className="full-width controls__field-description">
								Make sure that Anyone can edit the file. Right-click on the Frame {'>'} Copy {'>'} Copy link to selection
							</div>
						</div>

						<div className="controls__field-group controls__field-group--label-block">
							<label htmlFor="builder">Page Builder</label>
							<Select
								id="builder"
								name='builder'
								value={builder}
								onChange={(e) => {
									let pageBuilder = e.target.value;
									setBuilder(pageBuilder);
									pageBuilder = pageBuilder.charAt(0).toUpperCase() + pageBuilder.slice(1);
									pageBuilder = pageBuilder.split('_')[0];
									setBreakpoints(eval(`breakpoints${pageBuilder}`));
								}}
								IconComponent={() => (
									<div className="control-select-arrow">
										<Iconify icon="material-symbols:keyboard-arrow-down" />
									</div>
								)}
							>
								<MenuItem value="elementorFree" style={{ fontSize: '12px' }}>Elementor{state.license.licenseId === 'free' ? ' (Paid)' : ' (3.10 or higher + Flex Container)'}</MenuItem>
								<MenuItem value="gutenberg" style={{ fontSize: '12px' }}>Gutenberg</MenuItem>
								<MenuItem value="webflow" style={{ fontSize: '12px' }}>Webflow</MenuItem>
								<MenuItem value="bricks" style={{ fontSize: '12px' }}>Bricks{state.license.licenseId === 'free' ? ' (Paid)' : ''}</MenuItem>
								<MenuItem value="breakdance" style={{ fontSize: '12px' }}>Breakdance{state.license.licenseId === 'free' ? ' (Paid)' : ''}</MenuItem>
							</Select>
						</div>

						{['elementorFree', 'elementor', 'gutenberg'].includes(builder) && (
							<div className='require-notices'>
								<strong style={{ display: "block", marginBottom: "3px" }}>Requirements:</strong>
								<ul>
									<li>
										<a href={'https://softlite.io/updater/softlite-io-integration.zip?v=' + Config.PLUGIN_VERSION} download>
											Click here to Download & Install Softlite.io Integration Plugin version {Config.PLUGIN_VERSION} <span className="moveUpDown" style={{ display: 'inline-block' }}><Iconify icon="bxs:download" width={14} height={14} style={{ transform: 'translateY(3px)' }} /></span>
										</a>
									</li>
									{!['gutenberg'].includes(builder) && (
										<>
											<li>Flexbox Container installation is mandatory.</li>
											<li>Paste data: Right-click Elementor Editor &gt; Choose "Paste from other site" &gt; Ctrl/Cmd+V.</li>
										</>
									)}
								</ul>
							</div>
						)}

						{['elementorFree', 'elementor'].includes(builder) && (
							<>
								<div className="controls__field-group">
									<label htmlFor="mergeElementsEnable">
										<span>Auto Tagging with AI <em>New</em></span>
									</label>
									<Switch
										checked={mergeElementsEnable ? true : false}
										onChange={(e) => {
											setMergeElementsEnable(e.target.checked);
										}}
										id='mergeElementsEnable'
									/>
									{mergeElementsEnable && (
										<div className="full-width c-gray-dark">
											Disable this function for layout issues. <a href={mergeElementsDocURL} target="_blank">Learn more →</a>
										</div>
									)}
								</div>

								<div className="controls__field-group">
									<a href="https://softlite.io/docs/figwebx/tag-figma-elements-into-page-builder-widgets/" target="_blank" className='full-width'>Manually tag Figma Elements into Page Builder Widgets →</a>
								</div>
							</>
						)}

						<div className="controls__field-group">
							<label htmlFor="reduceDomSize">
								<span>Reduce DOM Size with AI</span>
							</label>
							<Switch
								checked={reduceDomSize ? true : false}
								onChange={(e) => {
									setReduceDomSize(e.target.checked);
								}}
								id='reduceDomSize'
							/>
							{reduceDomSize && (
								<div className="full-width c-gray-dark">
									Disable this function when there's a layout issue
								</div>
							)}
						</div>

						{reduceDomSize && (
							<div className="controls__field-group controls__field-group--label-block">
								<label htmlFor="reduceDomSizeLevel">
									<span>Reduce DOM Size Level</span>
								</label>
								<Select
									id="reduceDomSizeLevel"
									name='reduceDomSizeLevel'
									value={reduceDomSizeLevel}
									onChange={(e) => {
										setReduceDomSizeLevel(e.target.value);
									}}
									IconComponent={() => (
										<div className="control-select-arrow">
											<Iconify icon="material-symbols:keyboard-arrow-down" />
										</div>
									)}
								>
									<MenuItem value="standard" style={{ fontSize: '12px' }}>Standard (recommended)</MenuItem>
									<MenuItem value="advanced" style={{ fontSize: '12px' }}>Advanced</MenuItem>
								</Select>
							</div>
						)}

						<div className="controls__field-group">
							<a href={uploadDocURL} target="_blank" className='full-width'>Auto upload images/icons/fonts to your server. Learn more →</a>
						</div>

						{builder === 'webflow' && (
							<>
								<div className="controls__field-group">
									<label htmlFor="webflowUploadAssets">
										<span>Upload images to assets</span>
									</label>
									<Switch
										checked={webflowUploadAssets ? true : false}
										onChange={(e) => {
											setWebflowUploadAssets(e.target.checked);
										}}
										id='webflowUploadAssets'
									/>
								</div>
								{webflowUploadAssets && (
									<div className="controls__field-group controls__field-group--label-block">
										<label htmlFor="webflowAPIToken">
											Webflow API Token
										</label>
										<TextField
											id="webflowAPIToken"
											name='webflowAPIToken'
											value={webflowAPIToken}
											onChange={(e) => {
												setWebflowAPIToken(e.target.value);
											}}
											type={showWebflowAPIToken ? 'text' : 'password'}
											className='webflowAPIToken'
											InputProps={{
												endAdornment: (
													<InputAdornment position="end">
														<IconButton onClick={() => setShowWebflowAPIToken(!showWebflowAPIToken)} edge="end">
															<Iconify icon={showWebflowAPIToken ? 'eva:eye-fill' : 'eva:eye-off-fill'} />
														</IconButton>
													</InputAdornment>
												),
											}}
										/>
									</div>
								)}
							</>
						)}

						<div className="controls__advanced">
							<div className="controls__advanced-header" onClick={() => setIsOpenAdvanced(!isOpenAdvanced)}>
								<span>Advanced settings</span>
								{!isOpenAdvanced && (
									<Iconify icon="akar-icons:chevron-down" />
								)}
								{isOpenAdvanced && (
									<Iconify icon="akar-icons:chevron-up" />
								)}
							</div>
							{isOpenAdvanced && (
								<div className="controls__advanced-content">
									{breakpoints.tabletLandscape && (
										<div className="controls__field-group">
											<label className='label-flex' htmlFor="breakpointsMobile">
												Tablet Landscape (px)
											</label>
											<TextField
												id="breakpointsTabletLandscape"
												name='breakpointsTabletLandscape'
												value={breakpoints.tabletLandscape}
												type='number'
												onChange={(e) => {
													setBreakpoints({ ...breakpoints, tabletLandscape: parseInt(e.target.value) });
													eval(`setBreakpoints${builder.charAt(0).toUpperCase() + builder.slice(1)}({...breakpoints, tabletLandscape: parseInt(e.target.value)})`);
												}}
											/>
										</div>
									)}

									{breakpoints.tablet && (
										<div className="controls__field-group">
											<label className='label-flex' htmlFor="breakpointsTablet">
												Tablet Portrait (px)
											</label>
											<TextField
												id="breakpointsTablet"
												name='breakpointsTablet'
												value={breakpoints.tablet}
												type='number'
												onChange={(e) => {
													setBreakpoints({ ...breakpoints, desktop: parseInt(e.target.value) + 1, tablet: parseInt(e.target.value) });
													eval(`setBreakpoints${builder.charAt(0).toUpperCase() + builder.slice(1)}({...breakpoints, tablet: parseInt(e.target.value)})`);
												}}
											/>
										</div>
									)}

									{breakpoints.mobileLandscape && (
										<div className="controls__field-group">
											<label className='label-flex' htmlFor="breakpointsMobileLandscape">
												Mobile Landscape (px)
											</label>
											<TextField
												id="breakpointsMobileLandscape"
												name='breakpointsMobileLandscape'
												value={breakpoints.mobileLandscape}
												type='number'
												onChange={(e) => {
													if (breakpoints.mobileLandscape) {
														setBreakpoints({ ...breakpoints, mobileLandscape: parseInt(e.target.value) });
														eval(`setBreakpoints${builder.charAt(0).toUpperCase() + builder.slice(1)}({...breakpoints, mobileLandscape: parseInt(e.target.value)})`);
													}
												}}
											/>
										</div>
									)}

									{breakpoints.phoneLandscape && (
										<div className="controls__field-group">
											<label className='label-flex' htmlFor="breakpointsPhoneLandscape">
												Phone Landscape (px)
											</label>
											<TextField
												id="breakpointsPhoneLandscape"
												name='breakpointsPhoneLandscape'
												value={breakpoints.phoneLandscape}
												type='number'
												onChange={(e) => {
													setBreakpoints({ ...breakpoints, phoneLandscape: parseInt(e.target.value) });
													eval(`setBreakpoints${builder.charAt(0).toUpperCase() + builder.slice(1)}({...breakpoints, phoneLandscape: parseInt(e.target.value)})`);
												}}
											/>
										</div>
									)}

									{breakpoints.phonePortrait && (
										<div className="controls__field-group">
											<label className='label-flex' htmlFor="breakpointsMobile">
												Phone Portrait (px)
											</label>
											<TextField
												id="breakpointsPhonePortrait"
												name='breakpointsPhonePortrait'
												value={breakpoints.phonePortrait}
												type='number'
												onChange={(e) => {
													setBreakpoints({ ...breakpoints, phonePortrait: parseInt(e.target.value) });
													eval(`setBreakpoints${builder.charAt(0).toUpperCase() + builder.slice(1)}({...breakpoints, phonePortrait: parseInt(e.target.value)})`);
												}}
											/>
										</div>
									)}

									{breakpoints.mobile && (
										<div className="controls__field-group">
											<label className='label-flex' htmlFor="breakpointsMobile">
												{builder === 'breakdance' ? 'Phone' : 'Mobile'} Portrait (px)
											</label>
											<TextField
												id="breakpointsMobile"
												name='breakpointsMobile'
												value={breakpoints.mobile}
												type='number'
												onChange={(e) => {
													setBreakpoints({ ...breakpoints, mobile: parseInt(e.target.value) });
													eval(`setBreakpoints${builder.charAt(0).toUpperCase() + builder.slice(1)}({...breakpoints, mobile: parseInt(e.target.value)})`);
												}}
											/>
										</div>
									)}

									<div className="controls__field-group controls__field-group--label-block">
										<div className="flex flex-space-between align-center margin-bottom-10">
											<label className='label-flex' htmlFor="copyFontface">
												CSS @font-face
											</label>
											{copyFontface === 'copy' && canCopyFontface && (
												<div className="copy" onClick={() => handleCopyFontface()}>{copyFontfaceText}</div>
											)}
										</div>
										<Select
											id="copyFontface"
											name='copyFontface'
											value={copyFontface}
											onChange={(e) => {
												let copyFontface = e.target.value;
												setCopyFontface(copyFontface);
											}}
											IconComponent={() => (
												<div className="control-select-arrow">
													<Iconify icon="material-symbols:keyboard-arrow-down" />
												</div>
											)}
										>
											<MenuItem value="export" style={{ fontSize: '12px' }}>Add it to the export data</MenuItem>
											<MenuItem value="copy" style={{ fontSize: '12px' }}>Copy it to your site yourself</MenuItem>
										</Select>
									</div>
								</div>
							)}
						</div>
					</div>
				</div>
				<div className="panel__footer">
					<div className="panel__footer-left">
					</div>
					<div className="panel__footer-right">
						{/* {['elementor', 'webflow'].includes(builder) && (
							<LoadingButton loading={exportLoading} onClick={() => handleExport()} variant="contained">{exportText}</LoadingButton>
						)} */}
						{['elementor', 'elementorFree', 'webflow', 'bricks', 'breakdance', 'gutenberg'].includes(builder) && (
							<LoadingButton loading={exportLoading} onClick={() => handleExport()} variant="contained" className={upgrade && !['webflow', 'gutenberg'].includes(builder) || error !== null || figmaLink.trim() === '' ? 'export-button export-button--disabled' : 'export-button'}>Create</LoadingButton>
						)}
					</div>
				</div>
				{error && (
					<div className="panel__notice">
						<div className="panel__notice-icon">
							<Iconify icon="ph:info" />
						</div>
						<div className="panel__notice-body">
							{error === 1 && (
								<a href="https://softlite.io/docs/figwebx/import-from-figma/" target="_blank" rel="noreferrer">Failed. We can't access the Figma file <strong>→ Please follow this document</strong></a>
							)}
							{error === 10 && (
								<span>You have reached the maximum number of exports allowed by your license.</span>
							)}
							{![1,10].includes(error) && (
								<span dangerouslySetInnerHTML={{ __html: error }} />
							)}
						</div>
					</div>
				)}
				{upgrade && (
					<>
						<div className="panel__notice">
							<div className="panel__notice-icon">
								<Iconify icon="ph:info" />
							</div>
							<div className="panel__notice-body">
								The responsive is not available in the Free plan
							</div>
						</div>
						<div className="panel__upgrade">
							<a href={'https://softlite.io/pricing/figwebx/?email=' + state.user.email + '&first_name=' + state.user.first_name + '&last_name=' + state.user.last_name} target="_blank">
								<LoadingButton fullWidth variant="contained">Upgrade</LoadingButton>
							</a>
						</div>
					</>
				)}
			</div>
		</div>
	);
}

const textToSlug = (text: string) => {
	return text
		.toLowerCase()
		.replace(/ /g, '-')
		.replace(/[^\w-]+/g, '');
};

export default Panel;
